export interface IAppState {
  locale: string
  loading: boolean
  redirectTo: string | null
  help: any
}

export const AppDefaultState = (): IAppState => {
  return {
    locale: 'es',
    loading: false,
    redirectTo: null,
    help: {
      show: false,
      title: '',
      subtitle: '',
      message: ''
    }
  }
}
